import compileVariableUtil from '../../../../static/js/compileVariableUtil'

/**
type={code:"",name:""}
refer={id:".",code:"",name:""}
*/
export default function (validateItem, formItem, fCreateApi) {
  //  validateItem.type = null;
  // objectRefer 是自定义字段，与pattern 共用参数（存URL）

  validateItem.trigger = 'blur'
  validateItem.validator = (rule, value, callback) => {
    // var formData = fCreateApi.getFormData();
    var validateFlag = true
    var msg = validateItem.message
    if (!msg) msg = '超出限定范围'

    if (validateItem.required) {
      if (value && typeof value === 'object') {
        if (value instanceof Array) {
          if (value.length == 0) {
            validateFlag = false
          }
        } else {
          if (value == null) {
            validateFlag = false
          }
          // else if (value.hasOwnProperty("id") && (!value.id || value.id ==
          //     '.')) {
          //   //refer={id:".",code:"",name:""}//value.id=='.' 表示 refer结构，id未必填
          //   validateFlag = false;
          // }
          else if (!value.code || value.code == '.') {
            validateFlag = false
          }
        }
      } else if (!value) {
        validateFlag = false
      }
    }

    if (validateFlag) {
      if (callback) callback()
    } else {
      if (callback) callback(new Error(msg))
    }
  }

  // console.log("validateConverterUtil.converterAdapter:validateItem",
  //   validateItem);
}
